import axios from "axios";

const API_BASE_URL = "https://backend.gouniquejourneys.co.uk/api/employee/attendance"; 

// Employee Check-In
export const checkIn = async (employeeId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/check-in`, { employeeId }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error during check-in:", error.response?.data || error.message);
    throw error;
  }
};

// Employee Check-Out
export const checkOut = async (employeeId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/check-out`, { employeeId }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error during check-out:", error.response?.data || error.message);
    throw error;
  }
};

// Update Last Active Timestamp
export const updateLastActive = async (employeeId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/update-last-active`, { employeeId }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating last active time:", error.response?.data || error.message);
    throw error;
  }
};

// Get Attendance Records
export const getAttendanceRecords = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/records`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching attendance records:", error.response?.data || error.message);
    throw error;
  }
};
